import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構への提出確認",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411123_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    useFurigana: true,
    hafWidth: true,
    type: "name",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "name",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "date",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "addressSearch",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者住所",
    keyword: "locationGroup",
    type: "locationGroup",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: "請求者メールアドレス（機構連絡用）",
    keyword: "demanderEmail",
    type: "mail",
  },
  {
    title: "請求者メールアドレス（機構連絡用）（確認用）",
    keyword: "demanderEmailConfirm",
    type: "mail",
  },
  {
    title: "代行者メールアドレス",
    keyword: "agentEmail",
    type: "mail",
    requiredIcon: true,
  },
  {
    title: "代行者メールアドレス（確認用）",
    keyword: "agentEmailConfirm",
    type: "mail",
    requiredIcon: true,
  },
];

const schema: any = {
  demanderEmail: {
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  demanderEmailConfirm: {
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  agentEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  agentEmailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
};

const schemaKiko: any = {
  demanderEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  demanderEmailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
};

export { steps, fakeTableList, schema, schemaKiko };
